import { DownloadItem, DownloadProgress, FocusSDK } from "@/utils";
import { downloadMessageFile } from "@/utils/chat/index";
import DownloadFileQueue, { SaveOption, DownloadOption } from "@/utils/DownloadFileQueue";
import { FileStatus } from "@/types/chat";
import Bus from "@/utils/bus";

class DownloadService {
  private static instance: DownloadService | null;
  private static downloadingMids: string[] = [];
  private static updateDownloadingMids: (mids: string[]) => {};
  public static getInstance({
    updateDownloadingMids
  }: {
    updateDownloadingMids?: Function;
  }): DownloadService {
    if (!this.instance) {
      this.instance = new DownloadService({ updateDownloadingMids });
    }
    if (updateDownloadingMids) {
      DownloadService.updateDownloadingMids = updateDownloadingMids as any;
    }
    return this.instance;
  }

  private downloadItemMap: Map<number, any> = new Map();
  private downloadOptionsMap: Map<number, any> = new Map();
  private downloadSaveOption: Map<number, SaveOption> = new Map();
  private downloadStatus: Map<any, string> = new Map();
  private downloadRetryTime: Map<number, any> = new Map();

  constructor(props: any) {
    console.log("DownloadService-props=>", props);
    // DownloadService.updateDownloadingMids = props.updateDownloadingMids || null;
  }

  public download = (
    { viewFile, saveAs, message, auto, isGroup, isMergeForward, originMessage }: SaveOption,
    options: DownloadOption
  ) => {
    const mid = isMergeForward ? `${message.muuid}${originMessage.mid}` : message.mid;
    // if(this.downloadSaveOption.has(mid)) {
    //     this.downloadItemMap
    // }
    // 另存为时判断该文件是否已经在下载中，如果是需要把之前的下载中断
    const alreadySaveAs = saveAs && this.downloadSaveOption.has(mid);
    // if (alreadySaveAs) {
    //     this.clearServiceItem(mid);
    // }
    if (!auto) {
      DownloadFileQueue.getInstance()?.delQueue(mid);
    }
    const downloadOptions = {
      onStarted: (downloadItem: DownloadItem) => {
        if (!DownloadService.downloadingMids.includes(mid)) {
          DownloadService.downloadingMids.push(mid);
          DownloadService.updateDownloadingMids?.([...DownloadService.downloadingMids]);
        }
        this.downloadItemMap.set(mid, downloadItem);
        this.downloadStatus.set(mid, FileStatus.DOWNLOADING);
        this.downloadSaveOption.set(mid, { viewFile, saveAs, message, auto, isGroup });
        if (saveAs) {
          this.downloadRetryTime.delete(mid);
        }
        options.onStarted(downloadItem);
        FocusSDK.sendTrackLog({
          type: "DOWNLOAD",
          data: {
            sta_ts: new Date().getTime(),
            id: mid,
            url: message.url,
            f_s: message.size,
            f_n: message.name
          }
        });
      },
      onProgress: (progress: DownloadProgress) => {
        if (!DownloadService.downloadingMids.includes(mid)) {
          DownloadService.downloadingMids.push(mid);
          DownloadService.updateDownloadingMids?.([...DownloadService.downloadingMids]);
        }
        this.downloadStatus.set(mid, FileStatus.DOWNLOADING);
        options.onProgress(progress);
      },
      onCancel: () => {
        options.onCancel(alreadySaveAs);
      },
      onPause: () => {
        if (options.onPause) {
          this.downloadStatus.set(mid, FileStatus.CANCELED);
          options.onPause();
        }
      },
      onResume: () => {
        if (options.onResume) {
          this.downloadStatus.set(mid, FileStatus.DOWNLOADING);
          options.onResume();
        }
      },
      onFinish: async (file: { path: string; filename: string }, data: any) => {
        this.clearServiceItem(mid);
        this.downloadStatus.set(mid, FileStatus.COMPLETED);
        options.onFinish(file, data);
        FocusSDK.sendTrackLog({
          type: "DOWNLOAD",
          data: {
            end_ts: new Date().getTime(),
            id: mid,
            status: 1
          }
        });
      },
      onError: (error: any) => {
        if (options.onError) {
          // this.clearServiceItem(mid);
          console.log("onError=>", JSON.stringify(DownloadService.downloadingMids));
          this.downloadStatus.set(mid, FileStatus.FAILED);
          if (error.errorCode === 1017005) {
            this.clearServiceItem(mid);
            options.onError(error);
            return;
          }
          const errMsg = JSON.parse(error.error);
          if (errMsg.code === 2) {
            this.downloadRetryTime.set(mid, new Date().getTime());
          } else {
            this.clearServiceItem(mid);
          }
          options.onError(error);
        }
        FocusSDK.sendTrackLog({
          type: "DOWNLOAD",
          data: {
            end_ts: new Date().getTime(),
            id: mid,
            status: 2
          }
        });
      }
    };
    this.downloadOptionsMap.set(mid, downloadOptions);
    return downloadMessageFile(
      { viewFile, saveAs, message, auto, alreadySaveAs, originMessage },
      downloadOptions
    );
  };

  public setDownloadStatus = (mid: any, status: string) => {
    this.downloadStatus.set(mid, status);
  };

  public getDownloadStatus = (mid: any) => {
    const status = this.downloadStatus.get(mid);
    if (status) return status;
    return FileStatus.INIT;
  };

  public setDownloadRetryTime = (mid: number, time: number) => {
    this.downloadRetryTime.set(mid, time);
  };

  public getDownloadRetryTime = (mid: number) => {
    const time = this.downloadRetryTime.get(mid);
    return time;
  };

  public getSaveOption = (mid: number) => {
    const saveOption = this.downloadSaveOption.get(mid);
    if (saveOption) {
      return saveOption;
    }
    return null;
  };

  public getDLServiceItem = (mid: number, options: DownloadOption) => {
    const downloadItem = this.downloadItemMap.get(mid);
    const downloadOptions = this.downloadOptionsMap.get(mid);
    if (downloadOptions) {
      downloadOptions.onStarted = options.onStarted;
      downloadOptions.onProgress = options.onProgress;
      downloadOptions.onPause = () => {
        if (options.onPause) {
          this.downloadStatus.set(mid, FileStatus.CANCELED);
          options.onPause();
        }
      };
      downloadOptions.onResume = options.onResume;
      downloadOptions.onError = (error: any) => {
        if (options.onError) {
          // this.clearServiceItem(mid);
          this.downloadStatus.set(mid, FileStatus.FAILED);
          if (error.errorCode === 1017005) {
            this.clearServiceItem(mid);
            options.onError(error);
            return;
          }
          const errMsg = JSON.parse(error.error || "{}");
          if (errMsg.code === 2) {
            this.downloadRetryTime.set(mid, new Date().getTime());
          } else {
            this.clearServiceItem(mid);
          }
          options.onError(error);
        }
      };
      downloadOptions.onCancel = () => {
        if (options.onCancel) {
          options.onCancel();
        }
      };
      downloadOptions.onFinish = (file: { path: string; filename: string }, data: any) => {
        this.clearServiceItem(mid);
        this.downloadStatus.set(mid, FileStatus.COMPLETED);
        options.onFinish(file, data);
      };
      // return downloadOptions;
      return downloadItem;
    }
  };

  public clearServiceItem = (mid: number) => {
    this.downloadItemMap.delete(mid);
    this.downloadOptionsMap.delete(mid);
    this.downloadSaveOption.delete(mid);
    this.downloadRetryTime.delete(mid);
    const index = DownloadService.downloadingMids.findIndex((item: any) => item === mid);
    if (index > -1) {
      DownloadService.downloadingMids.splice(index, 1);
    }
    DownloadService.updateDownloadingMids?.([...DownloadService.downloadingMids]);
  };
}

export default DownloadService;
